import React, { useContext, useState, useEffect } from 'react';
import { auth } from '../firebase';
import { signInWithEmailAndPassword, onAuthStateChanged } from 'firebase/auth'; // Import necessary Firebase auth functions

const AuthContext = React.createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  async function login(email, password) { // Modified to accept email and password
    try {
      // Use Firebase signInWithEmailAndPassword
      await signInWithEmailAndPassword(auth, email, password);
      return true;
    } catch (error) {
      // Handle Firebase authentication errors
      throw new Error(error.message);
    }
  }

  async function logout() {
    try {
      // Use Firebase signOut
      await auth.signOut();
      setCurrentUser(null);
      console.log('User logged out successfully');
    } catch (error) {
      console.error('Error during logout:', error);
      // Optionally, you could set an error state here to display a message to the user
    }
  }

  useEffect(() => {
    // Use Firebase Authentication state observer
    const unsubscribe = onAuthStateChanged(auth, user => {
      setCurrentUser(user);
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const value = {
    currentUser,
    login,
    logout
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}